export const config = {
  GOOGLE_ANALYTICS: process.env.VUE_APP_GOOGLE_ANALYTICS || "",
  FIREBASE_API_KEY: process.env.VUE_APP_FIREBASE_API_KEY || "",
  FIREBASE_AUTH_DOMAIN: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN || "",
  FIREBASE_DATABASE_URL: process.env.VUE_APP_FIREBASE_DATABASE_URL || "",
  FIREBASE_PROJECT_ID: process.env.VUE_APP_FIREBASE_PROJECT_ID || "",
  FIREBASE_STORAGE_BUCKET: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET || "",
  FIREBASE_SENDER_ID: process.env.VUE_APP_FIREBASE_SENDER_ID || "",
  FIREBASE_APP_ID: process.env.VUE_APP_FIREBASE_APP_ID || "",
  FIREBASE_MEASUREMENT_ID: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID || "",
  SITE_ADDRESS: process.env.VUE_APP_SITE_ADDRESS || "",
  TELEGRAM_BOT: process.env.VUE_APP_TELEGRAM_BOT || "",
  VERSION: process.env.VUE_APP_VERSION || "0.0.0",
}
